module.exports = __webpack_public_path__ + "img/2.59b8f4d4.jpg";